module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_search_feature-db20c443084a354f03b2b2bc3430a7e9.svg";